import { checkAccount } from '../../src/components/Shared/CCPA';


export const onClientEntry = (_, pluginOptions) => {
    const { writeKey, trackPage, ccpaApiURL } = pluginOptions;
    if(typeof window !== `undefined` && window.DNS_OPTOUT) {
      window.onload = () => checkAccount(writeKey, trackPage, ccpaApiURL);
    }
  }
